/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAccessibility = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M14 9c2.206 0 4 1.794 4 4v3h-2v-3c0-.736-.405-1.375-1-1.722V22h-2v-4h-2v4H9V11.278c-.595.347-1 .986-1 1.722v3H6v-3c0-2.206 1.794-4 4-4zm-1 2h-2v5h2zm-1-9c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgAccessibility as Accessibility };
